import { withStyles } from '@material-ui/core';

import PlacementForm from './component';
import styles from './styles';

export default withStyles(styles)(PlacementForm);
